import { Injectable, computed, inject, signal } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { defaultIfEmpty, firstValueFrom } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { CurrentUserStore } from '../../../core/session/current-user.store';

type SidebarLogoutState = 'idle' | 'loading' | 'error';

@Injectable({
  providedIn: 'root',
})
export class SidebarAuthAdapterService {
  private msalService = inject(MsalService);
  private currentUserStore = inject(CurrentUserStore);

  readonly state = signal<SidebarLogoutState>('idle');
  readonly errorMessage = signal<string | null>(null);
  readonly isLoggingOut = computed(() => this.state() === 'loading');

  async logout(): Promise<void> {
    if (this.state() === 'loading') {
      return;
    }

    this.state.set('loading');
    this.errorMessage.set(null);

    try {
      this.currentUserStore.clear();

      await firstValueFrom(
        this.msalService
          .logoutRedirect({
            postLogoutRedirectUri: environment.msalConfig.auth.postLogoutRedirectUri,
          })
          .pipe(defaultIfEmpty(void 0))
      );

      this.state.set('idle');
    } catch {
      this.state.set('error');
      this.errorMessage.set('Nie udało się wylogować. Spróbuj ponownie.');
    }
  }
}
